import React from "react";

// Star SVG component
const Star = ({ filled, half }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      style={{ position: "relative", transform: "rotate(109deg)" }}
    >
      <path
        d="M10.6024 3.12087C10.2976 3.30557 9.91542 3.30554 9.61064 3.12082L4.93617 0.287591C4.21164 -0.151551 3.31596 0.498181 3.50848 1.32324L4.74776 6.63416C4.82827 6.97918 4.71153 7.34044 4.44435 7.57312L0.32977 11.1563C-0.307574 11.7113 0.0350516 12.7597 0.877163 12.8312L6.29958 13.2917C6.65268 13.3216 6.96029 13.5443 7.09903 13.8704L9.22706 18.8719C9.55734 19.6482 10.6576 19.6482 10.9879 18.8719L13.1159 13.8704C13.2546 13.5443 13.5623 13.3216 13.9154 13.2917L19.3378 12.8312C20.1799 12.7597 20.5225 11.7113 19.8852 11.1563L15.7706 7.57312C15.5034 7.34044 15.3867 6.97918 15.4672 6.63416L16.7065 1.32287C16.8991 0.497866 16.0035 -0.151863 15.2789 0.287164L10.6024 3.12087Z"
        fill={filled ? "#FFC500" : "#E0E0E0"}
      />
      {half && (
        <path
          d="M10.6024 3.12087C10.2976 3.30557 9.91542 3.30554 9.61064 3.12082L4.93617 0.287591C4.21164 -0.151551 3.31596 0.498181 3.50848 1.32324L4.74776 6.63416C4.82827 6.97918 4.71153 7.34044 4.44435 7.57312L0.32977 11.1563C-0.307574 11.7113 0.0350516 12.7597 0.877163 12.8312L6.29958 13.2917C6.65268 13.3216 6.96029 13.5443 7.09903 13.8704L9.22706 18.8719C9.55734 19.6482 10.6576 19.6482 10.9879 18.8719L13.1159 13.8704C13.2546 13.5443 13.5623 13.3216 13.9154 13.2917L19.3378 12.8312C20.1799 12.7597 20.5225 11.7113 19.8852 11.1563L15.7706 7.57312C15.5034 7.34044 15.3867 6.97918 15.4672 6.63416L16.7065 1.32287C16.8991 0.497866 16.0035 -0.151863 15.2789 0.287164L10.6024 3.12087Z"
          fill="#FFC500"
          style={{
            position: "absolute",
            left: "0",
            top: "0",
            width: "50%",
            height: "100%",
          }}
        />
      )}
    </svg>
  );
};

// Function to generate star rating
const StarRating = ({ averageRating }) => {
  const fullStars = Math.floor(averageRating);
  const halfStar = averageRating % 1 >= 0.5 ? 1 : 0;
  const emptyStars = 5 - fullStars - halfStar;

  return (
    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center ms-2 gap-2">
      {[...Array(fullStars)].map((_, index) => (
        <li key={index}>
          <Star filled={true} />
        </li>
      ))}
      {halfStar === 1 && (
        <li>
          <Star half={true} />
        </li>
      )}
      {[...Array(emptyStars)].map((_, index) => (
        <li key={index + fullStars + (halfStar === 1 ? 1 : 0)}>
          <Star filled={false} />
        </li>
      ))}
    </ul>
  );
};

export default StarRating;
